export default {
  "create-success": {
    EN: "API trigger created successfully.",
  },
  "create-failure": {
    EN: "Failed to create API trigger. Please try again.",
  },
  "update-success": {
    EN: "API trigger updated successfully.",
  },
  "update-failure": {
    EN: "Failed to update API trigger. Please try again.",
  },
  "delete-success": {
    EN: "API trigger deleted.",
  },
  "delete-failure": {
    EN: "Failed to delete API trigger. Please try again.",
  },
  "unblock-success": {
    EN: "API trigger unblocked successfully.",
  },
  "unblock-failure": {
    EN: "Failed to unblock API trigger. Please try again.",
  },
  "resend-success": {
    EN: "Delivery queued for resend.",
  },
  "resend-failure": {
    EN: "Failed to resend delivery. Please try again.",
  },
};
